import { API, TECHLEND_BE_URL } from '@/constants.api';
import { _get } from '@/services/crudService';

/**
 * Fetches the Direct Debit Request Service Agreement URL currently in effect for a loan's origin
 * type.
 *
 * The agreement used to be a build-time constant, which meant it could not vary by brand and a new
 * revision needed a front end deploy. The backend now owns it as a domain variable, and also owns
 * validating it, so this no longer has to mirror the bucket prefix the API will accept.
 *
 * Every failure — network, auth, an unconfigured document — resolves to an empty string rather than
 * throwing. That is the graceful degradation the direct debit screens rely on: the agreement phrase
 * renders as plain text, the form stays completable, and no `serviceAgreementUrl` is sent on submit
 * (the backend stamps the effective version on the mandate itself in that case).
 *
 * @param {string} applicationId The loan/application id
 * @returns {Promise<string>} The agreement URL, or '' when there is nothing usable
 */
export const fetchServiceAgreementUrl = async (applicationId) => {
  if (!applicationId) return '';
  try {
    const { data } = await _get(TECHLEND_BE_URL + API.DIRECT_DEBIT.SERVICE_AGREEMENT, { applicationId });
    return (data?.serviceAgreementUrl ?? '').trim();
  } catch (error) {
    return '';
  }
};
